import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';

import {
  CANCEL_PAUSE_REQUEST_MODAL_STAGES,
  setSelectedRequest,
  setCancelRequestModalStage,
} from 'features/courseResume';
import styles from './CancelRequestModalSuccessStage.module.scss';

function CancelRequestModalSuccessStage() {
  const dispatch = useDispatch();

  const handleCloseModal = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(null));
      dispatch(
        setCancelRequestModalStage(CANCEL_PAUSE_REQUEST_MODAL_STAGES.notOpen)
      );
    });
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleCloseModal();
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, handleCloseModal]);

  return (
    <div className={styles.root}>
      <div className={styles.cancelled}>Request Cancelled</div>
    </div>
  );
}

export default CancelRequestModalSuccessStage;
